// boilerplate code for downloading a csv
function downloadCSV(data, filename) {
  var element = document.createElement('a')
  element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(data))
  element.setAttribute('download', `${filename}.csv`)
  element.style.display = 'none'
  document.body.appendChild(element)
  element.click()
  document.body.removeChild(element)
}

export default downloadCSV
